function divideRecordsByDate(items) {
    console.log(items);
    if(!items || items.constructor !== Array){
        return [];
    }
    const res=[];
    let lastDate='';
    let count=-1;
    for(let i=0; i<items.length; i++){
        if(items[i].date!==lastDate){
            count++;
            res.push([]);
            lastDate=items[i].date;
        }
        res[count].push(items[i]);
    }
    if (res.length > 1 && new Date(res[0][0].date) > new Date(res[1][0].date)){
        res.reverse();
    }
    console.log(res);
    return res;
}

export function editUsernames (item) {
    item.usernames = item.usernames.slice(0, 3).join(", ") + (item.usernames.length > 3 ? '...' : '');
    return item;
}

export function editDateUsers (items) {
    console.log(items);
    let res = items;
    res.forEach((r) => editUsernames(r));
    res = divideRecordsByDate(res);
    return res;
}